import React from 'react';
import { Youtube, Linkedin, Instagram } from 'lucide-react';
import { socialLinks, type SocialIcon } from '../data/maintenance';
import { isSafeHttpUrl } from '../utils/url';
function XIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-627" data-mp="lvjld7qf5ylg">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.63l-5.196-6.79-5.943 6.79H1.75l7.49-8.56L1.084 2.25h6.8l4.713 6.231 5.647-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" data-id="element-628" data-mp="gxrhrggewo1f" />
    </svg>;
}
const icons: Record<SocialIcon, (props: {
  className?: string;
}) => JSX.Element> = {
  youtube: props => <Youtube {...props} aria-hidden="true" data-id="element-629" data-mp="14schdbqz1djh" />,
  x: XIcon,
  linkedin: props => <Linkedin {...props} aria-hidden="true" data-id="element-630" data-mp="zuav6hy90y3s" />,
  instagram: props => <Instagram {...props} aria-hidden="true" data-id="element-631" data-mp="1xa6nx40royrv" />
};
export function SocialLinks() {
  const safeLinks = socialLinks.filter(link => isSafeHttpUrl(link.href));
  return <ul className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-632" data-mp="1shn8e1iirtkf">
      {safeLinks.map(link => {
      const Icon = icons[link.icon];
      return <li key={link.label} data-id="element-633" data-mp="23fs4x77wivnl">
            <a href={link.href} target="_blank" rel="noopener noreferrer external" referrerPolicy="strict-origin-when-cross-origin" aria-label={link.label} className="flex h-10 w-10 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground" data-id="element-634" data-mp="23iwd0fohmbjj">
              <Icon className="h-4 w-4" data-id="element-635" data-mp="1jqq0jgomr7yk" />
            </a>
          </li>;
    })}
    </ul>;
}